module.exports = __webpack_public_path__ + "2aa89852b43038e8604e50cceafe22d9.svg";